import { cva } from 'class-variance-authority';
import React from 'react';

const rectangleClasses = cva('rounded-lg shadow-md  bg-white mx-3 p-2 justify-between flex-col', {
  variants: {
    fit: {
      three: 'w-[28%]', // Fit three rectangles in one row
      four: 'w-[20%]', // Fit four rectangles in one row
    },
    state: {
      default: '',
      hover: 'hover:bg-gray-300',
      active: 'bg-gray-400',
    },
  },
  defaultVariants: {
    fit: 'three',
    state: 'default',
  },
});

interface RectangleProps {
  fit?: 'three' | 'four';
  state?: 'default' | 'hover' | 'active';
  className?: string;
  title: string;
  content: string;
}

const Rectangle: React.FC<RectangleProps> = ({ fit, state, className, title, content, ...props }) => {
  return (
    <div className={`${rectangleClasses({ fit, state })} ${className}`} {...props}>
      <p className="mb-2 text-xs">{title}</p>
      <p className='text-xl font-semibold'>{content}</p>
    </div>
  );
};

export default Rectangle;